import {
  ColorClassnameMap,
  VariantClassnameMap,
  GradientBorderClassnameMap,
} from './types';

export const variantClassname: VariantClassnameMap = {
  text: 'disabled:opacity-30',
  outlined: 'disabled:opacity-30',
  contained: 'text-white disabled:opacity-30',
};

export const colorClassname: ColorClassnameMap = {
  info: {
    text: 'text-cyan-500 hover:bg-cyan-50',
    contained: 'bg-cyan-500 hover:bg-cyan-600',
    outlined: 'border-cyan-500 text-cyan-500 hover:bg-cyan-50',
  },
  success: {
    text: 'text-green-500 hover:bg-green-50',
    contained: 'bg-green-500 hover:bg-green-600',
    outlined: 'border-green-500 text-green-500 hover:bg-green-50',
  },
  secondary: {
    text: '',
    outlined: '',
    contained:
      'bg-accentGradient-secondary-primary hover:bg-accentGradient-secondary-hover active:bg-accentGradient-secondary-active',
  },
  error: {
    text: 'text-red-primary hover:bg-red-50',
    outlined: 'border-red-300 text-red-400 hover:bg-red-50',
    contained:
      'text-white bg-red-primary-primary hover:bg-red-primary-hover active:bg-red-primary-active',
  },
  warning: {
    text: 'text-yellow-500 hover:bg-yellow-50',
    outlined: 'border-yellow-500 text-yellow-500 hover:bg-yellow-50',
    contained:
      'text-red-primary-primary active:text-white bg-red-secondary-primary hover:bg-red-secondary-hover active:bg-red-secondary-active',
  },
  primary: {
    contained:
      'bg-accentGradient-primary-primary hover:bg-accentGradient-primary-hover active:bg-accentGradient-primary-active',
    text: 'bg-clip-text text-transparent bg-accentGradient-primary-primary hover:bg-accentGradient-primary-hover active:bg-accentGradient-primary-active',
    outlined:
      'bg-accentGradient-secondary-primary hover:bg-accentGradient-secondary-hover active:bg-accentGradient-secondary-active h-[37px] p-[8.5px] rounded-[calc(var(--radius-lg)-1px)] [&>span]:bg-clip-text [&>span]:text-transparent [&>span]:bg-accentGradient-primary-primary',
  },
};

export const gradientBorderClassname: GradientBorderClassnameMap = {
  primary: {
    outlined: 'p-[1.5px] bg-accentGradient-primary-primary rounded-lg h-10',
  },
};
